var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashWalletCloudUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloud upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66667 26.6667C6.64444 26.6667 4.91689 25.9667 3.484 24.5667C2.05022 23.1667 1.33333 21.4556 1.33333 19.4333C1.33333 17.7 1.85556 16.1556 2.9 14.8C3.94444 13.4444 5.31111 12.5778 7 12.2C7.55556 10.1556 8.66667 8.5 10.3333 7.23333C12 5.96667 13.8889 5.33333 16 5.33333C18.6 5.33333 20.8053 6.23867 22.616 8.04933C24.4276 9.86089 25.3333 12.0667 25.3333 14.6667C26.8667 14.8444 28.1391 15.5053 29.1507 16.6493C30.1613 17.7942 30.6667 19.1333 30.6667 20.6667C30.6667 22.3333 30.0836 23.7502 28.9173 24.9173C27.7502 26.0836 26.3333 26.6667 24.6667 26.6667H17.3333C16.6 26.6667 15.9724 26.4058 15.4507 25.884C14.928 25.3613 14.6667 24.7333 14.6667 24V17.1333L12.5333 19.2L10.6667 17.3333L16 12L21.3333 17.3333L19.4667 19.2L17.3333 17.1333V24H24.6667C25.6 24 26.3889 23.6778 27.0333 23.0333C27.6778 22.3889 28 21.6 28 20.6667C28 19.7333 27.6778 18.9444 27.0333 18.3C26.3889 17.6556 25.6 17.3333 24.6667 17.3333H22.6667V14.6667C22.6667 12.8222 22.0169 11.2498 20.7173 9.94933C19.4169 8.64978 17.8444 8 16 8C14.1556 8 12.5836 8.64978 11.284 9.94933C9.98356 11.2498 9.33333 12.8222 9.33333 14.6667H8.66667C7.37778 14.6667 6.27778 15.1222 5.36667 16.0333C4.45556 16.9444 4 18.0444 4 19.3333C4 20.6222 4.45556 21.7222 5.36667 22.6333C6.27778 23.5444 7.37778 24 8.66667 24H12V26.6667H8.66667Z",
    fill: "#20242A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashWalletCloudUploadIcon);
export default __webpack_public_path__ + "static/media/cash-wallet-cloud-upload-icon.a14e7027fbf67e15c04fadda646057e1.svg";
export { ForwardRef as ReactComponent };